import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_soustitre_1Texte, id_soustitre_1CouleurTexte, id_soustitre_1Opacite, id_soustitre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_soustitre_1Afficher}
                        onChange={(val) => setAttributes({ id_soustitre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_soustitre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_soustitre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_soustitre_1Opacite}
                        onChange={(val) => setAttributes({ id_soustitre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                {/* id_titre_1 */}
                {id_titre_1Afficher && (
                    <RichText 
                        tagName="h1" 
                        className="id_titre_1 " 
                        value={id_titre_1Texte} 
                        onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                    />
                )}
                {/* end-id_titre_1 */}
                {/* id_soustitre_1 */}
                {id_soustitre_1Afficher && (
                    <RichText 
                        tagName="h2" 
                        className="id_soustitre_1 " 
                        value={id_soustitre_1Texte} 
                        onChange={(val) => setAttributes({ id_soustitre_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_soustitre_1CouleurTexte, opacity: id_soustitre_1Opacite }} 
                    />
                )}
                {/* end-id_soustitre_1 */}
                {/* id_paragraphe_1 */}
                {id_paragraphe_1Afficher && (
                    <RichText 
                        tagName="p" 
                        className="id_paragraphe_1 " 
                        value={id_paragraphe_1Texte} 
                        onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                        placeholder="Saisir le texte..." 
                        style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                    />
                )}
                {/* end-id_paragraphe_1 */}
                <div className="row">
                    {/* id_card_1 */}
                    <div className="col-12 col-md-6 col-lg-4">
                        {/* id_card_1_icon_1 */}
                        <img id="id_card_1_icon_1" src="attribut_id_card_1_icon_1_src" alt="attribut_id_card_1_icon_1_alt" />
                        {/* end-id_card_1_icon_1 */}
                        {/* id_card_1_titre_1 */}
                        <h3 id="id_card_1_titre_1">
attribut_id_card_1_titre_1_texte
                        </h3>
                        {/* end-id_card_1_titre_1 */}
                        {/* id_card_1_paragraphe_1 */}
                        <p id="id_card_1_paragraphe_1">
attribut_id_card_1_paragraphe_1_texte
                        </p>
                        {/* end-id_card_1_paragraphe_1 */}
                        {/* id_card_1_bouton_1 */}
                        <a id="id_card_1_bouton_1" href="attribut_id_card_1_bouton_1_lien" className="btn" role="button">
                            {/* id_card_1_bouton_1_texte */}
                            <span id="id_card_1_bouton_1_texte">
attribut_id_card_1_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_1_bouton_1_texte */}
                        </a>
                        {/* end-id_card_1_bouton_1 */}
                    </div>
                    {/* end-id_card_1 */}
                    {/* id_card_2 */}
                    <div className="col-12 col-md-6 col-lg-4">
                        {/* id_card_2_icon_1 */}
                        <img id="id_card_2_icon_1" src="attribut_id_card_2_icon_1_src" alt="attribut_id_card_2_icon_1_alt" />
                        {/* end-id_card_2_icon_1 */}
                        {/* id_card_2_titre_1 */}
                        <h3 id="id_card_2_titre_1">
attribut_id_card_2_titre_1_texte
                        </h3>
                        {/* end-id_card_2_titre_1 */}
                        {/* id_card_2_paragraphe_1 */}
                        <p id="id_card_2_paragraphe_1">
attribut_id_card_2_paragraphe_1_texte
                        </p>
                        {/* end-id_card_2_paragraphe_1 */}
                        {/* id_card_2_bouton_1 */}
                        <a id="id_card_2_bouton_1" href="attribut_id_card_2_bouton_1_lien" className="btn" role="button">
                            {/* id_card_2_bouton_1_texte */}
                            <span id="id_card_2_bouton_1_texte">
attribut_id_card_2_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_2_bouton_1_texte */}
                        </a>
                        {/* end-id_card_2_bouton_1 */}
                    </div>
                    {/* end-id_card_2 */}
                    {/* id_card_3 */}
                    <div className="col-12 col-md-6 col-lg-4">
                        {/* id_card_3_icon_1 */}
                        <img id="id_card_3_icon_1" src="attribut_id_card_3_icon_1_src" alt="attribut_id_card_3_icon_1_alt" />
                        {/* end-id_card_3_icon_1 */}
                        {/* id_card_3_titre_1 */}
                        <h3 id="id_card_3_titre_1">
attribut_id_card_3_titre_1_texte
                        </h3>
                        {/* end-id_card_3_titre_1 */}
                        {/* id_card_3_paragraphe_1 */}
                        <p id="id_card_3_paragraphe_1">
attribut_id_card_3_paragraphe_1_texte
                        </p>
                        {/* end-id_card_3_paragraphe_1 */}
                        {/* id_card_3_bouton_1 */}
                        <a id="id_card_3_bouton_1" href="attribut_id_card_3_bouton_1_lien" className="btn" role="button">
                            {/* id_card_3_bouton_1_texte */}
                            <span id="id_card_3_bouton_1_texte">
attribut_id_card_3_bouton_1_texte_texte
                            </span>
                            {/* end-id_card_3_bouton_1_texte */}
                        </a>
                        {/* end-id_card_3_bouton_1 */}
                    </div>
                    {/* end-id_card_3 */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}